import { render, staticRenderFns } from "./SleepInfographic.vue?vue&type=template&id=3c43dbe8&"
import script from "./SleepInfographic.vue?vue&type=script&lang=ts&"
export * from "./SleepInfographic.vue?vue&type=script&lang=ts&"
import style0 from "./SleepInfographic.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports